export const PERMISSION_ENABLED = "permission enabled";
export const PERMISSION_DISABLED = "permission disabled";
